import { EpgProgram } from './EpgProgram';
import { Consts, IPlayer } from './index';

export const listenForPropertiesAndDoSomething = (observer: IPlayer) => {
  observer.on(
    getPropChangeEventName(Consts.PROPERTY_PLAYING_PROGRAM),
    (event) => {
      if (event.data) {
        const program = event.data as EpgProgram;
        program.channel._setActiveProgram(program);
      }
    },
  );
};

function getPropChangeEventName(eventName: string) {
  return `property:${eventName}`;
}
